// frontend/src/components/payroll/PayStub/helpers.ts
// Pure formatting helpers for the pay stub. No React, no state.

/**
 * Format a monetary value as en-CA with 2 decimals.
 * Handles negatives (prepends "-"), optionally prepends "$".
 */
export function money(
  value: number | string | null | undefined,
  symbol: boolean = false
): string {
  const n = Number(value) || 0;
  const body = Math.abs(n).toLocaleString("en-CA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const sign = n < 0 ? "-" : "";
  return sign + (symbol ? "$" : "") + body;
}

/**
 * Format a plain number as en-CA with 2 decimals (no currency symbol).
 * Used for hours in the Pay table.
 */
export function num(value: number | string | null | undefined): string {
  const n = Number(value) || 0;
  return n.toLocaleString("en-CA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * Format an ISO date as dd-mm-yyyy. Returns empty string on missing input,
 * returns the raw string on an unparseable date.
 */
export function formatDate(iso?: string | null): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  const dd = String(d.getUTCDate()).padStart(2, "0");
  const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
  const yyyy = d.getUTCFullYear();
  return dd + "-" + mm + "-" + yyyy;
}